import React, {useEffect, useState} from "react";
import axiosInstance from "../../api/axios";
import {showErrorNotify, showSuccessNotify, showWarningNotify} from "../../components";
import {connect} from 'react-redux';
import {Button, fetchEnd, fetchStart, refreshView} from 'react-admin';
import {compose} from 'redux';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import Swal from "sweetalert2";
import {change, submit} from "redux-form";
import utils from "../../utils/utils";

const AcceptTransferBtn = (props) => {
    const {record} = props;
    const [showBtn, setShowBtn] = useState(false);

    useEffect(() => {
        setShowBtn(record.id && record.status == 'DRAFT')
    }, [record])

    const handleClick = (e) => {
        e.stopPropagation();
        if (showBtn) {

            Swal.fire({
                title: "Bạn chắc chắn xác nhận khoản nạp thẻ này?",
                text: "Sau khi xác nhận, số tiền " + utils.formatNumber(record.amount) + " sẽ được nạp cho " + record.customerName,
                type: 'warning',
                showCloseButton: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
                focusConfirm: false,
            })
                .then((result) => {
                    if (result.value) {
                        const url = `/api/bankTransferTopupConsolidates/accept/${record.id}`;
                        axiosInstance.post(url)
                            .then((res) => {
                                if (res.data && res.data.success) {
                                    showSuccessNotify("Xác nhận khoản nạp thẻ thành công.");
                                    window.location.reload()
                                } else {
                                    showWarningNotify("Xác nhận khoản nạp thẻ không thành công.");
                                }
                            }).catch(err => {
                            showErrorNotify("Có lỗi xảy ra, vui lòng thử lại hoặc liên hệ quản trị viên");
                        })
                    }
                })

        }
    };

    return (
        <>
            {showBtn &&
            <Button color="primary" style={{width: 150}}
                    onClick={handleClick} label={'Xác nhận'}>
                <PlayArrowIcon/>
            </Button>
            }
        </>
    )
}


const mapStateToProps = state => ({});

const mapDispatchToProps = {
    change,
    fetchEnd,
    fetchStart,
    submit,
    refreshView
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(
    AcceptTransferBtn
);
